import { render, staticRenderFns } from "./SetPassWord.vue?vue&type=template&id=5a3d71f2&scoped=true&"
import script from "./SetPassWord.vue?vue&type=script&lang=js&"
export * from "./SetPassWord.vue?vue&type=script&lang=js&"
import style0 from "./SetPassWord.vue?vue&type=style&index=0&id=5a3d71f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d71f2",
  null
  
)

export default component.exports